export const INVESTOR_DATA = "INVESTOR_DATA";
export const INVESTOR_START_LOADER = "INVESTOR_START_LOADER";
export const INVESTOR_STOP_LOADER = "INVESTOR_STOP_LOADER";
export const INVESTOR_HIDE_ERROR = "INVESTOR_HIDE_ERROR";
export const INVESTOR_SET_ERROR = "INVESTOR_SET_ERROR";
